<div class="bg" animate.enter="entering">
  <div class="home-container">
    <div class="headline">
      <div class="text_container">
        <h1 class="header">The stage in your pocket.</h1>
      </div>
    </div>
    <div class="content">
      <app-content-card>
        <app-back-button [color]="Color"></app-back-button>
        <app-chat></app-chat>
        <app-about-backstage class="accent"></app-about-backstage>
        <h2 class="accent">tags.</h2>
        <app-chip [chips]="chips" class="accent bg"></app-chip>
        <app-links
          class="accent"
          Instagram="{{ Instagram }}"
          Facebook="{{ Facebook }}"
        ></app-links>
        <app-footer class="accent"></app-footer>
      </app-content-card>
    </div>
  </div>
</div>
